export const getProviderQuery = state => state.providerReducer.query;

export const getQueried = state => state.providerReducer.queried;
